export default __webpack_public_path__ + "static/media/sports.1c61f0f1.png";